export const PAGE_SIZE = 50;

export const REVIEW_STATUS = {
  pending: 'pending',
  confirmed: 'confirmed',
  rejected: 'rejected',
  all: 'all'
};

export const REVIEW_STATUS_TITLES = {
  [REVIEW_STATUS.pending]: 'Pending',
  [REVIEW_STATUS.confirmed]: 'Confirmed',
  [REVIEW_STATUS.rejected]: 'Rejected',
  [REVIEW_STATUS.all]: 'All'
};
